import apiClient from '@/services/api/apiClient';
import { buildApiUrl } from '../utils';
import {
  GetMediaUniformSeasonResponse,
  PostMediaUniformSeasonResponse,
  GetMediaUniformSeasonByIdResponse,
  PutMediaUniformSeasonResponse,
} from '../response/uniform-season';

export class UniformSeasonService {
  static getUniformSeasons() {
    return apiClient.get<GetMediaUniformSeasonResponse>(buildApiUrl('/api/v1/media/uniform-season'));
  }

  static postUniformSeason(data: any) {
    return apiClient.post<PostMediaUniformSeasonResponse>(buildApiUrl('/api/v1/media/uniform-season'), data);
  }

  static getUniformSeasonById(id: string) {
    return apiClient.get<GetMediaUniformSeasonByIdResponse>(buildApiUrl('/api/v1/media/uniform-season/:id', { id }), undefined);
  }

  static putUniformSeason(id: string, data: any) {
    return apiClient.update<PutMediaUniformSeasonResponse>(buildApiUrl('/api/v1/media/uniform-season/:id', { id }), data);
  }

  static deleteUniformSeason(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/media/uniform-season/:id', { id }), undefined);
  }
}
